import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { updateAttributeNestedProperty } from './design-system.helper';

@Injectable({
  providedIn: 'root',
})
export class DesignSystemService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public listenForAttributeUpdates<Type extends object>(
    component: Type,
    element: HTMLElement,
    callback?,
  ) {
    return this.renderer.listen(
      element,
      'updateProperty',
      (event: CustomEvent) => {
        const updates = event.detail;

        updates.forEach(({ attribute, propertyPath, newValue }) => {
          component[attribute] = updateAttributeNestedProperty(
            component[attribute],
            propertyPath,
            newValue,
          );
        });

        if (callback) {
          callback();
        }
      },
    );
  }
}
